module.exports = __webpack_public_path__ + "img/profiles.4f24a361.png";